
$(function(){
  $('.js-topNav').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).removeClass('active').find('span').text('+ VIEW MORE');
      $(this).prev().removeClass('active');
      $(this).prev().find('li:nth-child(n+10)').slideUp();
    } else {
      $(this).addClass('active').find('span').text('- VIEW LESS');
      $(this).prev().addClass('active');
      $(this).prev().find('li:nth-child(n+10)').slideDown();
    }
  });
  $('.staff_gradation_accordion button').on('click', function() {
    if($(this).hasClass('active')) {
        
      var position = $("#staff_comment").offset().top - 100;
      $('body,html').animate({scrollTop:position}, 300, 'swing');
      $(this).removeClass('active').find('span').text('+ VIEW MORE');
      $(this).closest('.staff_gradation_accordion').removeClass('open');
    } else {
      $(this).addClass('active').find('span').text('- VIEW LESS');
      $(this).closest('.staff_gradation_accordion').addClass('open');
    }
  });
  $('.header__secondary-nav .relative.header__cart-link a').on('click', function() {
    location.href = "/cart";
    return false;
  });
});

function resizeBadges() {
  const lists = [...document.querySelectorAll('.badge_list')];

  const baseHeight = window.innerWidth <= 999
    ? window.innerWidth * 0.102564
    : 42;

  // リセット
  lists.forEach(list => {
    list.style.height = 'auto';
    list.style.maxHeight = 'none';

    const inner = list.querySelector('.badge_list_inner');
    if (inner) {
      inner.style.transform = 'scale(1)';
      inner.style.width = '100%';
    }
  });

  // 行グループ
  const rows = {};
  lists.forEach(list => {
    const top = Math.round(list.getBoundingClientRect().top);
    if (!rows[top]) rows[top] = [];
    rows[top].push(list);
  });

  // 行ごと処理
  Object.values(rows).forEach(row => {

    const rowData = [];

    row.forEach(list => {
      const inner = list.querySelector('.badge_list_inner');
      if (!inner) return;

      const actualHeight = inner.scrollHeight;
      if (!actualHeight) return;

      let scale = 1;
      let finalHeight = actualHeight;

      // ★2行を超える場合のみ縮小
      if (actualHeight > baseHeight) {
        scale = baseHeight / actualHeight;
        scale = Math.max(scale, 0.7);
        finalHeight = actualHeight * scale;
      }

      rowData.push({ list, inner, scale, finalHeight });
    });

    // ------------------------
    // ★ここが核心
    // ------------------------
    const rowHeight = Math.max(
      ...rowData.map(d => Math.min(d.finalHeight, baseHeight))
    );

    // 適用
    rowData.forEach(d => {
      d.inner.style.transform = `scale(${d.scale})`;
      d.inner.style.width = `${100 / d.scale}%`;

      d.list.style.height = `${rowHeight}px`;
      d.list.style.maxHeight = `${rowHeight}px`;
    });
  });
}

window.addEventListener('load', resizeBadges);
window.addEventListener('resize', resizeBadges);
let timer;
const observer = new MutationObserver(() => {
  clearTimeout(timer);
  timer = setTimeout(resizeBadges, 100);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

setTimeout(resizeBadges, 300);
setTimeout(resizeBadges, 800);
setTimeout(resizeBadges, 1500);